<template>
  <div class="filters" :class="{'query-has-focus': queryIsFocused}">
    <div class="filter-page-size btn-group d-none d-md-inline-block" role="group">
      <FilterBarButton :button-value="10" :current-value="numberOfElements" :on-click="setNumberOfElements" />
      <FilterBarButton :button-value="25" :current-value="numberOfElements" :on-click="setNumberOfElements" />
      <FilterBarButton :button-value="songs.length" :current-value="numberOfElements" :on-click="setNumberOfElements" :text="'Tous'" />
    </div>
    <select v-model="numberOfElements" class="form-control d-md-none number-of-elements-picker" >
      <option :value="10">10</option>
      <option :value="25">25</option>
      <option :value="songs.length">Tous</option>
    </select>
    <select v-model="orderBy" class="form-control d-md-none order-by-picker ml-1">
      <option :value="ORDER_BY_DATE">Trier par date</option>
      <option :value="ORDER_BY_NAME">Trier par nom</option>
    </select>
    <div class="filter-query-group ml-1 mr-1">
      <input :value="query" @input="e => setQuery(e.target.value)" type="search" class="form-control" placeholder="Filtre" aria-label="Filtre" @focus="queryIsFocused = true" @blur="queryIsFocused = false">
      <i v-if="query == ''" class="fa fa-search"></i>
    </div>
    <div class="filter-order-by btn-group d-none d-md-inline-block">
      Trier par :
      <FilterBarButton :button-value="ORDER_BY_DATE" :current-value="orderBy" :on-click="setOrderBy" :text="'date'" />
      <FilterBarButton :button-value="ORDER_BY_NAME" :current-value="orderBy" :on-click="setOrderBy" :text="'nom'" />
    </div>
  </div>
</template>

<style>
  .filters {
    display: flex;
  }
  .filter-page-size {
    width: 200px;
    text-align: right;
  }
  .filter-order-by {
    width: 200px;
  }
  .filter-query-group {
    position: relative;
  }
  @media (min-width: 520px) {
    .filter-query-group input {
      transition: width 0.3s;
      width: 220px;
    }
    .filter-query-group input:focus {
      width: 280px;
    }
  }
  @media (max-width: 430px) {
    .filter-query-group, .filters {
      width: 100%;
    }
    .filters select {
      transition: all 0.3s;
      max-width: 145px;
    }
    .filters.query-has-focus select {
      max-width: 0;
      padding: 0;
      border: 0;
      opacity: 0;
    }
    .filter-query-group input.form-control::placeholder {
      opacity: 0;
    }
  }
  .filter-query-group i.fa-search {
    position: absolute;
    right: 11px;
    top: 11px;
    color: #989898;
  }
  .filters-button-group, .filter-query-group {
    display: inline-block;
  }
  .number-of-elements-picker, .order-by-picker {
    width: auto;
    display: inline-block;
  }
</style>

<script>
  import {mapState, mapGetters, mapActions} from "vuex";
  import FilterBarButton from "@/components/FilterBarButton";
  import {ORDER_BY} from "@/modules/songList.store";

  export default {
    components: {FilterBarButton},
    data() {
      return {
        queryIsFocused: false
      }
    },
    computed: {
      numberOfElements: {
        get() { return this.$store.state.songList.filters.numberOfElements },
        set(value) { this.$store.dispatch('setNumberOfElements', value); }
      },
      orderBy: {
        get() { return this.$store.state.songList.orderBy },
        set(value) { this.$store.dispatch('setOrderBy', value); }
      },
      ...mapState({
        query: state => state.songList.filters.query,
        songs: state => state.songList.songs
      }),
      ...mapGetters(["filteredSongs"])
    },
    methods: {
      ...mapActions(['setNumberOfElements', 'setQuery', 'setOrderBy'])
    },
    created() {
      this.ORDER_BY_DATE = ORDER_BY.DATE;
      this.ORDER_BY_NAME = ORDER_BY.NAME;
    }
  };
</script>
